/**
 * Gets the anti-forgery token from various possible sources
 * @returns The anti-forgery token or empty string if not found
 */
export function getAntiForgeryToken(): string {
  // Check window object first (some implementations put it there)
  if ((window as any).__RequestVerificationToken) {
    return (window as any).__RequestVerificationToken;
  }

  // Check for hidden input field (common in ASP.NET MVC)
  const tokenInput = document.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
  if (tokenInput?.value) {
    return tokenInput.value;
  }

  // Check meta tag (another common location)
  const tokenMeta = document.querySelector<HTMLMetaElement>('meta[name="__RequestVerificationToken"]');
  if (tokenMeta?.content) {
    return tokenMeta.content;
  }

  // Check for token in form data
  const forms = document.querySelectorAll('form');
  for (const form of forms) {
    const formToken = form.querySelector<HTMLInputElement>('input[name="__RequestVerificationToken"]');
    if (formToken?.value) {
      return formToken.value;
    }
  }

  console.warn('Anti-forgery token not found');
  return '';
}